import firebase from 'firebase/app';
import _ from 'lodash';
import { getUserAll, getTeamByCompany } from './cacheService';
import format from 'date-fns/format';
import axios from 'axios';
export default {
  namespaced: true,
  state: {
    allUser:{},
    status:false,
    allTeam:{},
    teamHeight:'',
    organization:{},
    language:{}
  },
  mutations: {
    setAllUser(state:any, result:any) {
        state.allUser = result
      },
    setAllTeam(state:any, result:any) {
        state.allTeam = result
      },
      setTeamHeight(state:any, result:any) {
        state.teamHeight = result
      },
      setOrganization(state:any, result:any) {
        state.organization = result
      },
      setLanguage(state:any, result:any) {
        state.language = result
      }
  },
  actions: {
    async getuser({ commit, state, rootState }: any, force: boolean = false) {
      // If data already exists and force is false, resolve immediately
      if (!force && state.allUser && Object.keys(state.allUser).length > 0) {
        return Promise.resolve(state.allUser);
      }
       
      try {
        const userData = await getUserAll(rootState.authen.user.company)
        const teamData = await getTeamByCompany(rootState.authen.user.company)
        
        
       
          commit('setAllUser', userData);
          commit('setAllTeam', teamData);
        return userData
        
        //return Promise.resolve(userData || {});
      } catch (error) {
        console.error('Error loading user data:', error);
        return Promise.reject(error);
      }
    },
    async removeUser({commit,state,rootState,dispatch}:any,update:any){
        return new Promise((resolve, reject) => {
         
            var axios = require('axios');
            var data = JSON.stringify({
              "c": rootState.authen.user.company,
              "t": "users"
            });
            const config = {
              method: 'post',
              url: 'https://api-node.happily.ai/cache/removeTable',
              headers: {
                'Content-Type': 'application/json'
              },
              data : data
            };
           axios(config)
            .then(response => {
              //console.log("data")
                const data = response.data
                resolve(data);
                dispatch("getuser",true)
            })
            .catch(err => {
              console.log("err",err)
                reject({ errorMessage: err.message });
            })
          
   
      });
  
  
  
  
    },
    async getteam({commit,state,rootState}:any,update:any){
      
        const teamData = await getTeamByCompany(rootState.authen.user.company)

        commit('setAllTeam',teamData)
        return teamData
        // var axios = require('axios');
        // var data = JSON.stringify({
        //   "c": rootState.authen.user.company,
        //   "t": "team"
        // });
        
        // const config = {
        //   method: 'post',
        //   url: 'https://api-node.happily.ai/cache/get',
        //   headers: {
        //     'Content-Type': 'application/json'
        //   },
        //   data : data
        // };
        // axios(config)
        // .then(function (response) {
        //   const data = response.data
        //   commit('setAllTeam',data)
        // })
        // .catch(function (error) {
        //   console.log(error);
        // });

      

    },
    async getteamHeight({commit,state,rootState}:any){
            let topmostArr: Array<any> = [];
            let teamHeight:any
            let team = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            for(const i in team){
                team[i].key=i
                if(!team[i].parent){
                  topmostArr.push(i)
                }
            }
            teamHeight = topmostArr[0]
            if(topmostArr.length > 1){
              teamHeight = _.find(topmostArr, (value) => {
              const chk_topmost = _.find(team, { parent: value });
              return !!chk_topmost;
              });
            }
            //console.log("teamHeight",teamHeight)
            commit('setTeamHeight',teamHeight)
    },
    async getOrganization({commit,state,rootState}:any){
      const result={}
      // console.log('getOrganization')
      await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
      .then((querySnapshot)=> {
              querySnapshot.forEach((doc)=> {
                const team_id=doc.data().team_id
                if(!result[team_id]){
                  result[team_id]=doc.data().parent
                }
              });
              //console.log('result',result)
              commit('setOrganization', result)  
      }); return result
    },
    async getLanguage({commit,state,rootState}:any){
      const LANG_FALLBACK:any = {
        'th': {name: 'Thai', code: 'th'},
        'ms': {name: 'Bahasa Malaysia', code: 'ms'},
        'zh-HK': {name: 'Chinese (Traditional, Hong Kong)', code: 'zh-HK'},
        'pt-br': {name: 'Brazilian Portuguese', code: 'pt-br'},
        'my': {name: 'Burmese', code: 'my'}
      }
      const materlanguage=(await firebase.database().ref(`/language`).once('value')).val()
            let userLanguage=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            userLanguage=_.groupBy(userLanguage,'language')
            const languages:Array<any>=[]
            const lang_code={}
            for(const i in userLanguage){
                if(i === 'undefined' || !i) continue
                if(materlanguage[i]){
                    languages.push({name:materlanguage[i].name,code:materlanguage[i].code})
                    lang_code[materlanguage[i].name]=materlanguage[i].code
                } else if(LANG_FALLBACK[i]){
                    languages.push({name:LANG_FALLBACK[i].name,code:LANG_FALLBACK[i].code})
                    lang_code[LANG_FALLBACK[i].name]=LANG_FALLBACK[i].code
                }
            }
            commit('setLanguage',{languages,lang_code})
    },
    async addAndUpdateGoalTeam({commit,state,rootState}:any,payload: {teamId: string, goals: string}){
      const {teamId, goals} = payload;
      let newId: string = '';
      if(goals && teamId){
        newId = firebase.firestore().collection('goals_team').doc().id;
        await firebase.firestore().collection('goals_team').doc(newId).set({
          team_id:teamId,
          company:rootState.authen.user.company,
          user_id:rootState.authen.user.email,
          createdate:format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          goals:goals
        });
        
        const url='https://api-node.happily.ai/openai/get_goals_team';
        //const url='http://localhost:80/openai/get_goals_team';
        try {
          await axios.post(url,JSON.stringify({
            company_id:rootState.authen.user.company,
            team_id:teamId,
            goals:goals,
            goal_team_id:newId
          }),{
            headers: {
              'Content-Type': 'application/json'
            }
          });
          console.log('addAndUpdateGoalTeam success');
        } catch (error) {
          console.log('addAndUpdateGoalTeam error', error);
          throw error; // ส่ง error ต่อเพื่อให้ caller รู้
        }
      }
    }
  
  },
  getters: {
    allUser : (state:any) => {
      return state.allUser
    },
    allTeam : (state:any) => {
      return state.allTeam
    },
    teamHeight : (state:any) => {
      return state.teamHeight
    },
    organization : (state:any) => {
      return state.organization
    },
    language : (state:any) => {
      return state.language
    }
  }
}